module.exports = __webpack_public_path__ + "static/media/oven.4770f97a.svg";